var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-auto mb-auto"},[_c('v-btn',{staticClass:"black--text text",attrs:{"to":"/carrito","icon":""}},[_c('v-icon',[_vm._v("mdi-cart-plus")]),_c('sub',{staticClass:"blue--text"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.NumItems)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }